/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-11-14 11:43:22
 * @LastEditors: linxi
 * @LastEditTime: 2023-07-24 14:02:51
 */
import { Button, Col, Modal, notification, Row, Spin, Tooltip } from 'antd'
import React, { ReactElement, useContext, useEffect, useRef, useState } from 'react'
import styles from './peddingMedicalTreatment.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { getRecipeCategoryName } from '../../../models/recipe'
import { ThemeContext } from '../../../theme/ThemeContext'
import { EditableList } from '../../../compnents/list/EditableList'
import { Columns } from './column'
import { ExcuteDetailModal } from './recordOfExecutionModal'
import { ExcuteModal } from './ExecutionModal'
import { unwrapResult } from '@reduxjs/toolkit'
import { getBatchExecuteDetail } from './peddingMedicalTreatmentSlice'
import { PrintTemplateCategory } from '../../../models/print'
import { getPrintZXDData } from '../../treatment/editor/recipeEditorSlice'
import { PrintTemplateModal } from '../../print/PrintTemplateModal'
import { NoDataIcon } from '../../../compnents/icons/Icons'
import moment from 'moment'
import { DateTimeFormatSimples } from '../../../models/datetime'
import { selectUserId, selectUserName } from '../../../app/applicationSlice'

interface RecipeListItemProps {
  loading?: boolean
  patientId?: any
  data: any
  selectTabKey?: string
  refresh?: () => void
}

export const RecipeListItem = ({
  loading,
  patientId,
  data = [],
  selectTabKey,
  refresh,
}: RecipeListItemProps): ReactElement => {

  const theme = useContext(ThemeContext);

  const dispatch = useDispatch<RootDispatch>()

  const userId = useSelector(selectUserId)

  const userName = useSelector(selectUserName)

  const [treatmentId, setTreatmentId] = useState<any>()

  const [printTemplateCategory, setPrintTemplateCategory] = useState<
    PrintTemplateCategory | undefined
  >()

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [recordId, setRecordId] = useState('')

  const [recipeId, setRecipeId] = useState('')

  const [recipeItemId, setRecipeItemId] = useState('')

  const [isExcuteModalVisible, setIsExcuteModalVisible] = useState(false)

  const [singleState, setSingleState] = useState(true)

  const [printZXDData, setPrintZXDData] = useState<any>()

  const getReciptPrintList = (recipeId?: any) => {
    dispatch(getPrintZXDData(recipeId))
      .then(unwrapResult)
      .then((v: any) => {
        setPrintZXDData(v)
      })
  }

  return (
    <>
      <Spin spinning={loading} style={{ paddingTop: '100px' }}>
        {data?.length ? data?.map((v: any, index: number) => {
          return <div
            key={index}
            className={styles.recipelistItemMain}
          >
            <Row className={styles.recipelistItemTitleRow}
              style={{
                backgroundColor: theme.th,
              }}>
              <Col span={12}>
                <span style={{ fontWeight: 'bold' }}>{getRecipeCategoryName(v.category)}</span>，处方编号：
                {v.recipeId}
              </Col>
              <Col span={12} className={styles.recipelistItemTitleButton}>
                {/* selectTabKey == 1 已执行 */}
                {selectTabKey == '1' ? '' : <>
                  <Button
                    type="primary"
                    ghost
                    style={{ marginRight: 10 }}
                    onClick={() => {
                      Modal.confirm({
                        title: '全部执行后，当前处方单里的所有项目执行进度全部完成，请确认是否要全部执行？',
                        okText: '确认',
                        okType: 'primary',
                        onOk: () => {
                          const params = v?.medicalStationList?.map((item: any) => ({
                            ...item,
                            executeAll: true,
                            executeTime: item?.executeTime ? moment(item?.executeTime).format(DateTimeFormatSimples) : moment().format(DateTimeFormatSimples),
                            operatorId: item?.operatorId || userId,
                            operatorName: item?.operatorName || userName,
                          }))
                          dispatch(getBatchExecuteDetail(
                            params
                          ))
                            .then(unwrapResult)
                            .then((v) => {
                              notification.success({
                                message: '操作成功',
                              })
                              refresh && refresh()
                            })
                        },
                      })
                    }}>全部执行</Button>
                  <Button
                    type="primary"
                    style={{ marginRight: 10 }}
                    onClick={() => {
                      setIsExcuteModalVisible(true)
                      setSingleState(false)
                      setRecipeId(v.recipeId)
                    }}
                  >批量执行</Button>
                </>}
                <Button
                  type="primary"
                  onClick={() => {
                    if (v?.recipeId) {
                      setRecipeId(v?.recipeId)
                      setTreatmentId(v?.treatmentId)
                      getReciptPrintList(v?.recipeId)
                      setPrintTemplateCategory(PrintTemplateCategory.Zxd)
                    }
                  }
                  }>打印
                </Button>
              </Col>
            </Row>
            <EditableList
              bordered
              pagination={false}
              page={{
                items: v?.medicalStationList || [],
                current: 1,
                size: 10,
                total: 0,
              }}
              columns={Columns((text, t) => {
                if (text == 'execute') {
                  setIsExcuteModalVisible(true)
                  setRecipeItemId(t.recipeItemId)
                  setRecipeId(v.recipeId)
                  setSingleState(true)
                } else if (text == 'record') {
                  setIsModalVisible(true)
                  setRecordId(t?.id)
                }
              }, selectTabKey)}
            />

          </div>
        }) : <div className={styles.noPageData}>
          <NoDataIcon
            style={{
              width: 200,
              height: 200,
              opacity: 0.5,
            }}
          />
          <span>暂无数据</span>

        </div>}
      </Spin>
      {/* 记录 */}
      <ExcuteDetailModal
        id={recordId}
        isModalVisible={isModalVisible}
        onOk={(() => {
          setIsModalVisible(false)
        })}
        onCancel={(() => {
          setIsModalVisible(false)
        })}
      />

      {/* 执行 */}
      <ExcuteModal
        singleState={singleState}
        recipeId={recipeId}
        recipeItemId={recipeItemId}
        isModalVisible={isExcuteModalVisible}
        onOk={(() => {
          setIsExcuteModalVisible(false)
          setRecordId('')
          refresh && refresh()
        })}
        onCancel={(() => {
          setIsExcuteModalVisible(false)
          setRecordId('')
        })}
      />
      <PrintTemplateModal
        patientId={patientId}
        printZXDData={printZXDData}
        pagePrintFlag={'zxdPrint'}
        visible={!!printTemplateCategory}
        templateCategory={printTemplateCategory}
        recipeId={recipeId}
        treatmentId={treatmentId}
        onCancel={() => setPrintTemplateCategory(undefined)}
        onOk={() => setPrintTemplateCategory(undefined)}
      />
    </>
  );
}
